import { fetcher, FWS_BASE_URL } from "@fwa/src/services/apiClient";
import { type TeamMemberType } from "@fwa/src/types";

export const createTeamMember = ({
  data = {},
  parentPageUniqueId,
  childPageUniqueId,
}: {
  data: { membershipStatus: string } | Record<string, never>;
  parentPageUniqueId: string;
  childPageUniqueId: string;
}): Promise<TeamMemberType> =>
  fetcher(
    `${FWS_BASE_URL}/pages/${parentPageUniqueId}/pages/${childPageUniqueId}/teammembers`,
    {
      method: "POST",
      body: JSON.stringify(data),
    },
  ).then((res) => res as TeamMemberType);

export const fwsUrlMember = ({ memberId }: { memberId: string }) =>
  `${FWS_BASE_URL}/teammembers/${memberId}`;
